import { ReadDataService } from "../../../services/base/ReadDataService";
import { BalanceUnit } from "../models/BalanceUnit";
import { BalanceUnitQuery } from "../models/BalanceUnitQuery";

export class BalanceUnitService extends ReadDataService<BalanceUnit,BalanceUnitQuery, number> {
  protected prefixUrl: string = `BalanceUnits`;
}
